<template>
    <div class="modal modal--popup account-loading-modal" :class="{'is-open' : isOpen }">
        <div class="modal-overlay"></div>
        <div class="modal__content">
            <div class="new-loader alt-loader">
                <div class="loader-content">
                    <div class="star-wrapper">
                        <svg class="star"><use xlink:href="#star"></use></svg>
                        <svg class="mask"><use xlink:href="#mask-alt"></use></svg>
                    </div>
                </div>
            </div>
            <h2>Loading your <span id='account-loading-text'>travel inspo...</span></h2>
        </div>
    </div>
</template>
<script>
export default {

    data() {
        return {
            words: ['travel inspo...', 'new fave restaurant...', 'recommendations...'],
            isOpen: false,
            accountLoadingCounter: 0,
        }
    },

    mounted() {
        eventBus.$on('start-processing-payment-dialog', () => {
            this.startAnimation()
        })
        eventBus.$on('stop-processing-payment-dialog', () => {
            this.isOpen = false
        })
    },

    methods: {

        startAnimation() {
            this.isOpen = true
            $('.account-loading-modal .new-loader .star-wrapper:not(.animated)').addClass('animated');
            setInterval(this.accountLoadingAnimation, 2000);
        },

        accountLoadingAnimation() {
            $('#account-loading-text').addClass('fade');

            setTimeout(() => {
                $('#account-loading-text').text(this.words[this.accountLoadingCounter]);
                $('#account-loading-text').removeClass('fade');
            }, 500);

            this.accountLoadingCounter++;
            if (this.accountLoadingCounter >= this.words.length) {
                this.accountLoadingCounter = 0
            }
        }
    }
}
</script>
